import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Products} from '../../../models/Products';
import {ProductsService} from '../../../core/services/acquista-servizi/products/products.service';
import {ProductsStore} from '../../../core/services/acquista-servizi/products/products.store';

@Component({
  selector: 'app-add-new-product-modal',
  templateUrl: './add-new-product-modal.component.html',
  styleUrls: ['./add-new-product-modal.component.scss']
})
export class AddNewProductModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<string>,
    @Inject(MAT_DIALOG_DATA) public data: number,
    private productsService: ProductsService,
    public productStore: ProductsStore
  ) {
  }

  prezzo: number;
  doubleFormatRegex = '^-?[0-9]\\d*(\\.\\d*)?$';
  nomeProdotto: string;
  durataGiorni: number;
  descrizione: string;
  tipoProdotto: any;
  iva: number;
buttonText: string;
  onNoClick(): void {
    this.dialogRef.close(null);
  }

  onYesClick(): void {
    this.dialogRef.close({
      prezzo: this.prezzo, nomeProdotto: this.nomeProdotto,
      durataGiorni: this.durataGiorni,
      descrizione: this.descrizione,
      tipoProdotto: this.tipoProdotto,
      iva: this.iva
    });
  }

  getById(id: number) {
    this.productsService.getById(id).subscribe((res: Products) => {
      this.prezzo = this.productStore.product.price;
      this.nomeProdotto = this.productStore.product.name;
      this.durataGiorni = this.productStore.product.credits;
      this.descrizione = this.productStore.product.description;
      this.iva = this.productStore.product.iva;
      if (this.productStore.product.isConsumable === false && this.productStore.product.isSubscription === true ) {
        this.tipoProdotto = 'Abbonamento' ;
      } else if (this.productStore.product.isConsumable === false && this.productStore.product.isSubscription === false) {
        this.tipoProdotto = 'Servizio a Consumo' ;
      } else if (this.productStore.product.isConsumable === true && this.productStore.product.isSubscription === false) {
        this.tipoProdotto = 'Servizio Una Tantum' ;
      }
    });
  }
  ngOnInit(): void {
    this.buttonText = this.data ? 'Aggiorna Prodotto' : 'Aggiungi Prodotto';
    if (this.data) {
      const id = this.data;
      this.getById(id);
    }
  }
}
